var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 136,
    viewBox: "0 0 132 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.9382,
    y1: 2,
    x2: 49.9382,
    y2: 134,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41.9321,
    y1: 27.8589,
    x2: 41.9321,
    y2: 108.141,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 65.9507,
    y1: 39.3521,
    x2: 65.9507,
    y2: 96.6478,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 97.9753,
    y1: 45.0981,
    x2: 97.9753,
    y2: 90.901,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 113.988,
    y1: 41.2676,
    x2: 113.988,
    y2: 94.7324,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 57.9443,
    y1: 18.2822,
    x2: 57.9443,
    y2: 117.719,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 105.981,
    y1: 27.8589,
    x2: 105.981,
    y2: 108.141,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 33.926,
    y1: 45.0981,
    x2: 33.926,
    y2: 90.901,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 17.9136,
    y1: 41.2676,
    x2: 17.9136,
    y2: 94.7324,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 25.9197,
    y1: 61.3804,
    x2: 25.9197,
    y2: 74.6198,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 61.3804,
    x2: 2,
    y2: 74.6198,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 9.90747,
    y1: 54.6763,
    x2: 9.90747,
    y2: 81.3242,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 73.9568,
    y1: 54.6763,
    x2: 73.9568,
    y2: 81.3242,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 89.969,
    y1: 54.6763,
    x2: 89.969,
    y2: 81.3242,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 121.994,
    y1: 54.6763,
    x2: 121.994,
    y2: 81.3242,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 81.9629,
    y1: 61.3804,
    x2: 81.9629,
    y2: 74.6198,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 61.3804,
    x2: 130,
    y2: 74.6198,
    stroke: "#B3D7FC",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioFile);
export default __webpack_public_path__ + "static/media/audio_file.1ca6d4bacbc1f4706d29d7b085a50f24.svg";
export { ForwardRef as ReactComponent };